import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import {
  Form,
  Formik,
  Field,
  ErrorMessage
} from 'formik';
import { Messages } from '../../components/layout/Messages/Messages';
import { Auth } from '../layout/Auth';
import { EmailField } from '../../components/pages/auth/EmailField';
import { LoginLinks } from '../../components/layout/Auth/LoginLinks';
import { PasswordField } from '../../components/pages/auth/PasswordField';
import { CheckboxField } from '../../components/pages/auth/CheckboxField';
import { requestLogin, requestLoginPasskey } from '../../store/actions/user';
import { LoginSchema } from '../../helpers/schemas';
import {
  goToForgotPassword
} from '../../helpers/location';
import * as types from "../../store/actions/types";
import { FEATURE_PASSKEY } from '../../config/features';
import './Login.scss';

function LoginComponent(props) {

  const { requestLogin, goToForgotPassword, requestLoginPasskey } = props;
  
  return (
    <div className="login-page">
      <Auth title={<FormattedMessage id="app.login.login_page_title"/>}
            lead={<FormattedMessage id="app.login.login_page_description"/>}>
        <Formik
          initialValues={{ email: '', password: '', remember_login: false }}
          validationSchema={LoginSchema}
          validateOnChange={false}
          onSubmit={(values,{setSubmitting}) => {
            requestLogin( values.email, values.password, values.remember_login );
            setSubmitting(false)
          }}
        >
          {(props) => (
            <Fragment>
              <Messages
                color="danger"
                type={types.NOTIFICATION_ERROR}
                formikProps={props}
              >
                <ErrorMessage name="email" component="div"
                              data-testid="errors-email"
                              className="field-error"/>
                <ErrorMessage name="password" component="div"
                              data-testid="errors-password"
                              className="field-error"/>
              </Messages>
              <Messages color="success" notificationId="loginSuccessMessages"/>
              <Form className="login-page__form">
                <EmailField handleBlur={props.handleBlur}/>
                <PasswordField handleBlur={props.handleBlur}/>
                <CheckboxField
                  checked={props.values.remember_login}
                  className="login-page__remember"
                />
                <div className="login-page__actions text-center">
                  <FormattedMessage id="app.login.sign_in_button">
                    {
                      valueBtn => <Field name="submit"
                                         className="login-page__submit mt-4 btn btn-info d-block mx-auto"
                                         color="info" type="submit"
                                         value={valueBtn}/>
                    }
                  </FormattedMessage>
                  {
                    FEATURE_PASSKEY &&
                    <FormattedMessage id="app.login.sign_in_passkey_button">
                      {
                        valueBtn => 
                        <Field name="submit_passkey"
                          className="login-page__passkey my-4 btn btn-outline-info d-block mx-auto"
                          color="info"
                          value={valueBtn}
                          type="button"
                          onClick={() => { requestLoginPasskey(); }}
                        />
                      }
                    </FormattedMessage>
                  }
                </div>
              </Form>
            </Fragment>
          )}
        </Formik>
      </Auth>
      <div className="login-page__links">
        <LoginLinks forgotLink={goToForgotPassword}/>
      </div>
    </div>
  );
}

LoginComponent.defaultProps = {
  goToForgotPassword,
};

const mapActionsToProps = {
  requestLogin,
  requestLoginPasskey,
};

const Login = connect( null, mapActionsToProps )( LoginComponent );

export { Login, LoginComponent };
